<script setup>
import { useCalendar } from '@daysmart/daysmart-vue-components/composables'
import { useCalendarSettings } from '../composables/useCalendarSettings'

const { customFirstDayOfWeek } = useCalendarSettings()
const calendar = useCalendar({ customFirstDayOfWeek })
const daysOfWeek = computed(() => calendar.getWeekView.value().map(e => e.format('ddd')))
</script>

<template>
  <div class="m-2 mt-0 flex overflow-x-auto lt-sm:(m-0 mb-2 border-1 border-surface-600 rounded-2 bg-surface-500) !lt-sm:hidden">
    <template v-for="day of daysOfWeek">
      <p class="flex flex-1 justify-center whitespace-nowrap px-4 py-2 text-sm text-text-500 font-semibold lt-sm:(min-w-104px border-r-1 border-surface-600 font-normal last:border-r-0)">
        {{ day }}
      </p>
    </template>
  </div>
</template>
